<template>
  <div class="about">
    <div class="personnal">
      <h1>Tanguy Michel</h1>
      <img src="/img/profil.png" alt="">
      <div class="tasklist">
        <ul>
          <li>Tache 1</li>
          <li>Tache 2</li>
          <li>Tache 3</li>
          <li>Tache 4</li>
          <li>Tache 5</li>
        </ul>
      </div>
    </div>
    <div class="personnal">
      <h1>Antoine Marteau</h1>
      <img src="/img/profil.png" alt="">
      <div class="tasklist">
        <ul>
          <li>Tache 1</li>
          <li>Tache 2</li>
          <li>Tache 3</li>
          <li>Tache 4</li>
          <li>Tache 5</li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    components: {
    },
    data: function() {
      return {
      }
    }
  }
</script>
<style scoped lang="scss">
  .about{
    display: flex;
    align-items: center;
    height: 90vh;
    overflow-x: auto;
  }

  .about::-webkit-scrollbar {
    margin:20px;
    width: 5px;
    background: #888;
    border-radius:10px;
  }
  .about::-webkit-scrollbar-thumb {
    background: #000000;
    border-radius:10px;
  
  }
.personnal{
  padding:25px;
  flex:2;
  text-align: center;
  color:white;
  .tasklist{
    text-align: initial;
    display: flex;
    justify-content: center;
  }
}
</style>